import { FX_DEFAULT } from "@/components/editor/ClipPanel";
import { migrateFx, sliceKfs } from "@/lib/layerMotion";
import { sliceAud } from "@/lib/clipAudio";

export function layout(clips, fullDuration) {
  let acc = 0, vi = 0, prevLen = 0;
  return clips.map((c) => {
    const full = fullDuration(c);
    const inn = Math.min(c.in ?? 0, full - 0.1);
    const out = Math.min(c.out ?? full, full);
    const r = { ...c, in: inn, out, len: Math.max(0.1, out - inn) };
    if (c.track === "video") {
      const d = vi > 0 && c.trans && c.trans.type !== "none" ? Math.min(c.trans.dur, prevLen * 0.9, r.len * 0.9) : 0;
      r.start = acc - d; r.transDur = d; r.idx = vi++;
      acc = r.start + r.len; prevLen = r.len;
    }
    if (c.track === "fx") r.fx = migrateFx({ ...FX_DEFAULT, ...(c.fx || {}) }, r.len);
    return r;
  });
}

export function splitAt(clips, c, t) {
  const cut = +(c.in + (t - c.start)).toFixed(3);
  return clips.flatMap((x) => x.id !== c.id ? [x] : [
    { ...x, in: c.in, out: cut, ...(c.fx && { fx: { ...c.fx, ...sliceKfs(c.fx, 0, t - c.start) } }), ...(c.aud && { aud: sliceAud(c.aud, 0, t - c.start, "left") }) },
    { ...x, id: crypto.randomUUID(), in: cut, out: c.out, trans: undefined, start: x.track === "video" ? 0 : +t.toFixed(3),
      ...(c.fx && { fx: { ...c.fx, ...sliceKfs(c.fx, t - c.start, c.len) } }), ...(c.aud && { aud: sliceAud(c.aud, t - c.start, c.len, "right") }) },
  ]);
}

export const reorder = (cs, cid, idx) => {
  const moving = cs.find((c) => c.id === cid);
  const vids = cs.filter((c) => c.track === "video" && c.id !== cid);
  vids.splice(Math.max(0, Math.min(idx, vids.length)), 0, moving);
  return [...vids, ...cs.filter((c) => c.track !== "video")];
};
